module.exports = __webpack_public_path__ + "static/media/item-2.c60f1ede.png";